// Source: https://github.com/Juceztp/vue-dayjs
import Vue from 'vue'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import relativeTime from 'dayjs/plugin/localizedFormat'

dayjs.extend(utc)
dayjs.extend(relativeTime)

Vue.prototype.$date = dayjs